/**
 * FRONTEND §3.1 — the status → tone map, shared by the three routes that show one (`jobs`,
 * `job`, `feed`). An exhausted `Record` per machine: adding a status to the contract without a
 * tone here is a compile error, not a silently neutral chip.
 */
import { type JobStatus, type QuoteState } from '@marketplace/contracts';
import { type BadgeTone } from '@marketplace/ui';

const JOB_TONES: Record<JobStatus, BadgeTone> = {
  DRAFT: 'neutral',
  OPEN: 'primary',
  CANCELLED: 'neutral',
  AWARDED: 'success',
  // `W4-T09` §2.6: as `AWARDED` — the engagement is going well, now attested.
  IN_PROGRESS: 'success',
};

/* `QuoteState`, not `QuoteStatus`: the job page renders what `quoteStatusOf` derived, and a quote
   whose `validUntil` passed reads EXPIRED whatever the stored status says. */
const QUOTE_TONES: Record<QuoteState, BadgeTone> = {
  PENDING: 'neutral',
  WITHDRAWN: 'neutral',
  EXPIRED: 'neutral',
  ACCEPTED: 'success',
  REJECTED: 'danger',
  AWARDED: 'success',
};

export function jobTone(status: JobStatus): BadgeTone {
  return JOB_TONES[status];
}

export function quoteTone(status: QuoteState): BadgeTone {
  return QUOTE_TONES[status];
}
